module.exports = __webpack_public_path__ + "static/domestic_mental_obj01_m@2x-6c0ba0a4cdd4edadc87e7bb5f084c78f.jpg";